import {api} from '../../../shared';
import {CreateFundraiserDocumentDTO} from '../model';

export const fundraiserDocumentsApi = {
  createDocument: async (appealId: string, dto: CreateFundraiserDocumentDTO): Promise<void> => {
    await api.post<void>(`/api/fundraising/admin/appeals/${appealId}/documents`, dto);
  },

  deleteDocument: async (appealId: string, documentId: string): Promise<void> => {
    await api.delete<void>(`/api/fundraising/admin/appeals/${appealId}/documents/${documentId}`);
  },
};
